const defaultNumberFormat = {
  currency: {
    style: 'currency',
    currency: 'EUR',
  },
} as const;

export const NUMBER_FORMATS = {
  currency: 'currency',
};

export const numberFormats = {
  'it-IT': defaultNumberFormat,
  'en-GB': defaultNumberFormat,
};
